import appConstant from "../../appConstants"
const routeNameCellStyling = params => {
    // show route color to only when the route is selected
    if(params.data.routeName !== appConstant.UNRTD_ROUTENAME && params.node.isSelected()){
        return { borderColor:`${params.data.color}` }
    } else {
        return { borderColor:`${appConstant.Colors.transparent}`}
    }
}
export { routeNameCellStyling }